module.exports = __webpack_public_path__ + "static/media/logo-navy-with-icon-group-white.8e728268.svg";